import React, { useEffect } from 'react';

import { useSelector } from 'react-redux';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { toastifySelector } from '../../../store/selectors';

function Toastify() {
  const message = useSelector(toastifySelector);
  const { value, theme, isError } = message;

  useEffect(() => {
    const settings = {
      position: "bottom-right",
      autoClose: 10000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      theme: theme,
    };

    if(value && value.length) {
      if(isError) {
        toast.error(value, settings);
      } else {
        toast.success(value, settings);
      }
    }
  }, [message]);

  return (
    <ToastContainer/>
  );
}

export default Toastify;